module.exports = __webpack_public_path__ + "static/media/6_of_diamonds.31d0ccfc.png";